import { memo } from "react";
import { Box, Typography } from "@mui/material";
import TickIcon from "../../../../assets/svg-fc/TickIcon";
import { IQuoteFormStepper } from "../../../../types/quoteFormTypes";
import "./quoteFormStepper.scss";

const CorporateFormStepper = ({ steps, disabled, onClickStep }: IQuoteFormStepper) => {
	return (
		<Box className="stepperContainer">
			{steps.map(({ step, title, isActive, isCompleted }) => {
				return (
					<Box key={step}>
						<Box
							className={`stepperItem ${disabled ? "disabled" : isActive ? "active" : isCompleted ? "completed" : "upcoming"}`}
							onClick={() => !disabled && isCompleted && onClickStep(step)}
						>
							<Box className="stepCircle">
								{isCompleted ? <TickIcon /> : <Typography className="stepCircleNumber">{step}</Typography>}
							</Box>
							<Typography className="stepLabel">{title}</Typography>
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default memo(CorporateFormStepper);
